const layout = () => import('../../internal/dashboard/layoutV2.vue')
const labs = () => import('./labs.vue')

const labsRoutes = {
  component: layout,
  children: [
    {
      path: '/labs',
      name: 'labs',
      component: labs,
      meta: {
        title: "labs",
        requiresAuth: true,
      },
    },
  ],
}

export default labsRoutes
